export enum COMPANY_PARTNER_SOURCE {
  PARENT_COMPANY = "parent_company",
  DEFAULT = "default",
}
